import { Info, ShieldCheck, Captions } from "lucide-react";

export const Header = ({ onInfo, onPrivacy, device }) => (
  <header className="flex items-center justify-between h-14 px-4 border-b border-[var(--cc-border)] bg-[var(--cc-panel)]">
    <div className="flex items-center gap-2.5">
      <div className="h-8 w-8 rounded-md bg-[var(--cc-accent)] grid place-items-center">
        <Captions className="h-5 w-5 text-black" strokeWidth={2.5} />
      </div>
      <div className="leading-tight">
        <h1 className="text-base font-extrabold tracking-tight" data-testid="app-title">CaptionCraft <span className="text-[var(--cc-accent)]">AI</span></h1>
        <p className="text-[11px] text-[var(--cc-text-2)] hidden sm:block">On-device Hindi · English · Hinglish captions</p>
      </div>
    </div>
    <div className="flex items-center gap-1">
      <span className="hidden sm:inline-flex items-center text-[11px] font-semibold px-2 py-1 rounded border border-[var(--cc-border-strong)] text-[var(--cc-text-2)] mr-1" data-testid="device-badge">
        {device ? (device.webgpu ? "WebGPU ready" : "CPU mode") : "Checking device…"}
      </span>
      <button onClick={onPrivacy} aria-label="Privacy notice" data-testid="open-privacy-btn"
        className="h-10 px-2.5 rounded-md inline-flex items-center gap-1.5 text-xs font-semibold text-emerald-400 hover:bg-[var(--cc-elev)]">
        <ShieldCheck className="h-4 w-4" /> <span className="hidden sm:inline">100% local</span>
      </button>
      <button onClick={onInfo} aria-label="Help, setup and limitations" data-testid="open-info-btn"
        className="h-10 w-10 rounded-md grid place-items-center text-[var(--cc-text-2)] hover:bg-[var(--cc-elev)] hover:text-white">
        <Info className="h-5 w-5" />
      </button>
    </div>
  </header>
);
